import { css } from 'styled-components';
import { h2, text } from './text';
import { media, colors } from './constants';

// [Style] Tweak here to change blog/job posts styling
export default css`
  > * {
    max-width: 97rem;
  }

  .img-wrapper {
    @media (min-width: ${media.tabletPortrait}) {
      margin-top: 7.5rem;
      margin-bottom: 5rem;

      &:first-child {
        margin-bottom: 1rem;
      }
    }
  }

  .gatsby-image-wrapper,
  .embed {
    position: relative;
    max-width: 97rem;
    margin-top: 5rem;
    margin-bottom: 0;
    width: 100% !important; /* override Froala width */
    height: auto !important; /* override Froala height */
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  span,
  hr,
  ul,
  ol,
  table {
    padding-bottom: 2rem;
  }

  blockquote {
    padding-bottom: -1rem;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    padding-bottom: 1rem;
    ${h2}

    * {
      ${h2}
    }

    padding-top: 4rem;

    @media (min-width: ${media.tabletPortrait}) {
      padding-top: 5rem;
    }
  }

  table th {
    width: 50%;
  }

  ul,
  ol {
    padding-bottom: 2rem;

    @media (min-width: ${media.tabletPortrait}) {
      padding-bottom: 2em;
    }
  }

  ul {
    list-style: none;

    li::before {
      content: '•';
      color: ${colors.blue};
      display: inline-block;
      width: 1rem;
      padding-right: 1.5rem;
    }
  }

  ol {
    list-style: none;
    counter-reset: ol-counter;

    li {
      counter-increment: ol-counter;
    }

    li::before {
      content: counter(ol-counter) '. ';
      color: ${colors.blue};
      display: inline-block;
      width: 1rem;
      padding-right: 1.5rem;
    }
  }

  li {
    ${text}
    padding-bottom: 1rem;
  }

  hr {
    border: none;
    display: flex;
    justify-content: center;
    font-size: 10rem;
    margin: 0;

    &:before {
      content: '∙∙∙';
      color: ${colors.cyan};
    }
  }
`;
